export default __webpack_public_path__ + "static/media/icon-duplicate.2c3baf75.svg";